import React, { } from 'react';
import { Redirect } from 'react-router-dom'
import { auth } from '../firebase';
import fakeAuth from './autha';
import { message, Input, Button } from "antd";
import { userInfo } from 'os';

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});


class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      error: null,
    }

  }

  //debug purpose
  componentDidMount() {
  
  }

  state = {
    redirectToReferrer: false
  }

  onSubmit = (event) => {
    const {
      email,
      password,
    } = this.state;

    // const {history} = this.props;

    auth.doSignInWithEmailAndPassword(email, password)
      .then(() => {
        this.setState({
          email: '',
          password: '',
          error: null,
        });
        message.destroy()
        message.success('Welcome!')
        this.loginla();
      })
      .catch(er => {
        // this.setState(byPropKey('error', error));
        message.destroy()
        message.error(er.message)
      });

  }

  loginla = () => {
    fakeAuth.authenticate(() => {
      this.setState(() => ({
        redirectToReferrer: true
      }))
    })
  }
  handleKey = (event) => {
    // 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
    if (event.key === 'Enter') {
      message.info('Loading...')
      if (this.state.email !== "" && this.state.password !== "") {
        event.preventDefault();
        event.stopPropagation();
        this.onSubmit();
      }
    }
  }
  render() {
    const { from } = this.props.location.state || { from: { pathname: '/' } }
    const { redirectToReferrer } = this.state

    const {
      email,
      password,
      error,
    } = this.state;

    const isInvalid =
      password === '' ||
      email === '';

    if (redirectToReferrer === true) {
      return <Redirect to={from} />
    }

    return (
      <div className="loginform" onKeyDown={this.handleKey}>
        <img src="/logo.png" alt='spsetia' />
        <form className="inputforma">
          <Input
            size="large"
            className="inputforma"
            value={email}
            onChange={event => this.setState(byPropKey('email', event.target.value))}
            type="text"
            placeholder="Email Address"
          />
          <Input
            size="large"
            className="inputforma"
            value={password}
            onChange={event => this.setState(byPropKey('password', event.target.value))}
            type="password"
            placeholder="Password"
          />

          <Button type="primary" className="buttona" disabled={isInvalid} onClick={this.onSubmit}>
            Sign In
        </Button>
          {/* {error && <p>{error.message}</p>} */}
        </form>
        {process.env.NODE_ENV !== 'production' ? <Button onClick={this.loginla}>CHEAT LOG IN</Button> : <div></div>}

      </div>
    )
  }
}

export default Login;


// WEBPACK FOOTER //
// ./src/views/login.js